<template>
	<div class="tab-pane-ip-wrapper">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- резервирование IP -->
		<div class="tab-pane-command-wrapper" style="margin-bottom: 60px">
			<div class="control-wrapper">
				<input type="checkbox" class="w5-checkbox-field" v-model="reserveIpValue" style="display: none" />
				<label @click="reserveIpStart" :class="{ 'disable': !Access || Status !== 'active' || reserveIpProcessing }" style="display: inline-block; height: 3em; line-height: 3em;">
					{{ 'service/reserve_ip' | ftc }}
				</label>
				<div class="warning-message" v-withSafeTags="localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)" style="margin-bottom: 5px"></div>
			</div>
		</div>

		<!-- IPv4 -->
		<template>
			<h4 style="margin-top: 10px">{{ 'service/ip4_count' | ftc }}</h4>

			<!-- данные о количествах и стоимости -->
			<div class="ip-count-info" v-if="Status === 'active'">
				<div class="ip-count-info-ip">
					<span class="ip-count-info-ip-item" v-withSafeTags="countIP4"></span>
					<span class="ip-count-info-ip-item" v-withSafeTags="costIP4"></span>
				</div>
			</div>

			<!-- кнопка удаления адресов
			<font-awesome-icon v-if="Status === 'active' && (ip4 && ip4['rows'] && ip4['rows'].length)"
				icon="trash-alt"
				class="pull-right ip-trash-button"
				:class="{ 'ip-trash-button-active': hasSelectedRowsIp4 }"
				:disabled="!Access || activeProcess ? 'disabled' : false"
				:title="'ippool/delete_selected_title' | ftc"
				@click="delIP('4')"
			/>
			-->

			<!-- таблица адресов -->
			<table class="w5-ip-table margin-top-5">
				<thead>
					<tr>
						<th class="w5-ip-table-th-0">
							<span>{{ 'ippool/ippool' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-1">
							<span>{{ 'ippool/host' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-2">
							<span>{{ 'ippool/gateway' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-3">
							<span>{{ 'ippool/netmask' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-4"></th>
					</tr>
				</thead>
				<tbody v-if="ip4 && ip4['rows'] && ip4['rows'].length">
					<tr v-for="(ip4, idx) in ip4['rows']"
						:class="{ 'w5-list-selected-row': ip4['selected'] === true }"
						:key="'ip4-' + ip4['id']">
						<td :aria-label="'ippool/ippool' | ftc"
							:class="{ 'color-red': ip4['status'] !== 'active' || ip4['status_text'] }"
							:style="ip4['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell">{{ ip4['address'] }}</span>
						</td>
						<td :aria-label="'ippool/host' | ftc" :style="ip4['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell"><span class="w5-modal-link" @click="changeHost(ip4, '4')">{{ ip4['host'] ? ip4['host'] : 'main/create ipptrpool/ipptrpool' | ftc }}</span></span>
						</td>
						<td :aria-label="'ippool/gateway' | ftc" :style="ip4['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell">{{ ip4['gateway'] }}</span>
						</td>
						<td :aria-label="'ippool/netmask' | ftc" :style="ip4['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell">{{ ip4['netmask'] }}</span>
						</td>
						<td>
							<dropDownButton v-if="Status === 'active' && !ip4['status_text'] && ip4['status'] === 'active'"
								:dataConfig="configOpersIp4"
								:row="ip4"
								:index="idx"
								crud="service"
								@action="actionOperButton"
							/>
							<!--
							<font-awesome-icon v-if="Status === 'active' && ip4['can_delete'] === true && !deletedIp4[ip4['id']]"
								icon="trash-alt"
								class="pull-right ip-trash-button ip-trash-button-active small"
								:disabled="!Access || activeProcess ? 'disabled' : false"
								:title="'main/deleting' | ftc"
								@click="delOneIP('4', ip4)"
							/>
							-->
						</td>
					</tr>
				</tbody>
				<!-- если таблица пустая -->
				<tbody v-else>
					<tr>
						<td colspan="4" class="text-center">
							<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
							<br>
							<span class="font-size-110 w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
						</td>
					</tr>
				</tbody>
			</table>

			<!-- кнопка покупки -->
			<span v-show="ip4['max'] && ip4['max'] > 0" class="btn btn-submit margin-top-15 font-weight-300" :disabled="!Access || !ipInfo || activeProcess ? 'disabled' : false" @click="buyIP('4')">{{ 'main/order service/ip4_count' | ftc }}</span>
		</template>

		<!-- IPv6 -->
		<template>
			<div style="height: 60px"></div>

			<h4>{{ 'service/ip6_count' | ftc }}</h4>

			<!-- данные о количествах и стоимости -->
			<div class="ip-count-info" v-if="Status === 'active'">
				<div class="ip-count-info-ip">
					<span class="ip-count-info-ip-item" v-withSafeTags="countIP6"></span>
					<span class="ip-count-info-ip-item" v-withSafeTags="costIP6"></span>
				</div>
			</div>

			<!-- кнопка удаления адресов
			<font-awesome-icon v-if="Status === 'active' && (ip6 && ip6['rows'] && ip6['rows'].length)"
				icon="trash-alt"
				class="pull-right ip-trash-button"
				:class="{ 'ip-trash-button-active': hasSelectedRowsIp6 }"
				:disabled="!Access || activeProcess ? 'disabled' : false"
				:title="'ippool/delete_selected_title' | ftc"
				@click="delIP('6')"
			/>
			-->

			<!-- таблица адресов -->
			<table class="w5-ip-table margin-top-5">
				<thead>
					<tr>
						<th class="w5-ip-table-th-0">
							<span>{{ 'ippool/ippool' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-1">
							<span>{{ 'ippool/host' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-2">
							<span>{{ 'ippool/gateway' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-3">
							<span>{{ 'ippool/netmask' | ftc }}</span>
						</th>
						<th class="w5-ip-table-th-4"></th>
					</tr>
				</thead>
				<tbody v-if="ip6 && ip6['rows'] && ip6['rows'].length" >
					<tr v-for="(ip6, idx) in ip6['rows']"
						:class="{ 'w5-list-selected-row': ip6['selected'] === true }"
						:key="'ip6-' + ip6['id']">
						<td :aria-label="'ippool/ippool' | ftc"
							:class="{ 'color-red': ip6['status'] !== 'active' || ip6['status_text'] }"
							:style="ip6['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell">{{ ip6['address'] }}</span>
						</td>
						<td :aria-label="'ippool/host' | ftc" :style="ip6['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell"><span class="w5-modal-link" @click="changeHost(ip6, '6')">{{ ip6['host'] ? ip6['host'] : 'main/create ipptrpool/ipptrpool' | ftc }}</span></span>
						</td>
						<td :aria-label="'ippool/gateway' | ftc" :style="ip6['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell">{{ ip6['gateway'] }}</span>
						</td>
						<td :aria-label="'ippool/netmask' | ftc" :style="ip6['can_delete'] === false ? 'font-weight: 500' : false">
							<span class="w5-table-cell">{{ ip6['netmask'] }}</span>
						</td>
						<td>
							<dropDownButton v-if="Status === 'active' && !ip6['status_text'] && ip6['status'] === 'active'"
								:dataConfig="configOpersIp6"
								:row="ip6"
								:index="idx"
								crud="service"
								@action="actionOperButton"
							/>
							<!--
							<font-awesome-icon v-if="Status === 'active' && ip6['can_delete'] === true && !deletedIp6[ip6['id']]"
								icon="trash-alt"
								class="pull-right ip-trash-button ip-trash-button-active small"
								:disabled="!Access || activeProcess ? 'disabled' : false"
								:title="'main/deleting' | ftc"
								@click="delOneIP('6', ip6)"
							/>
							-->
						</td>
					</tr>
				</tbody>
				<!-- если таблица пустая -->
				<tbody v-else>
					<tr>
						<td colspan="4" class="text-center">
							<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
							<br>
							<span class="font-size-110 w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
						</td>
					</tr>
				</tbody>
			</table>

			<!-- кнопка покупки -->
			<span v-show="ip6['max'] && ip6['max'] > 0" class="btn btn-submit margin-top-15 font-weight-300" :disabled="!Access || !ipInfo || activeProcess ? 'disabled' : false" @click="buyIP('6')">{{ 'main/order service/ip6_count' | ftc }}</span>
		</template>




		<!-- диалог удаления -->
		<transition name="modal">
			<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ deleteModalTitle | ftc }}</span>
							<button type="button" class="close" @click="hideDeleteModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(deleteModalText)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="deleteModalTimer && deleteModalTimer > 0 ? 'disabled' : false" @click="deleteBegin">{{ modalDeleteButtonTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>




		<!-- диалог смены хоста -->
		<transition name="modal">
			<div v-if="showHostModal" @mousedown="maskModalFlag = true" @mouseup="() => this.hideHostModal(false)" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" :class="hostModalContainerClass" @mousedown.stop="maskModalFlag = false" @mouseup.stop="maskModalFlag = false">

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ hostModalTitle | ftc }}</span>
							<button type="button" class="close" @click="hideHostModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding-top: 0">

							<!-- старое поле
							<div class="w5-form-row">
								<Field
									v-if="hostField && Access"
									:isVisibleRow="true"
									crud="vds"
									action="view"
									v-model="hostValue"
									:Field="hostField"
									@focus="onFocus(hostField)"
									@enterKeyDown="onEnterKeyDown"
									:fieldInModal="true"
									:removeRightPadding="true" />
							</div>
						-->

								<!-- таблица PTR-записей -->
								<Table v-if="selectedIpId"
									crud="ipptrpool"
									crud-search-model="IpPtrPoolSearch"
									:access="Access"
									:url-list="tableUrlList"
									:url-create="tableUrlCreate"
									:url-update="tableUrlUpdate"
									:columns="tableColumns"
									:inner-forms="true"
									:in-modal="true"
									create-button-title="ipptrpool/create_title"
									@error="getError"
									@title="value => hostModalTitle = value"
									@refresh="requestData"
									@containerClass="value => hostModalContainerClass = value"
									@currentMode="value => hostModalCurrentMode = value"
									id-columns="ptr_id"
									style="margin-top: 0" />

						</div>

						<!-- подвал пока не нужен
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="changeHostBegin">{{ 'ippool/update_type' | ftc }}</span>
						</div>
					-->
					</div>
				</div>
			</div>
		</transition>




		<!-- диалог покупки адресов -->
		<transition name="modal">
			<div v-show="showBuyModal" @click="hideBuyModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'ippool/buy_title' | ftc }}</span>
							<button type="button" class="close" @click="hideBuyModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									crud="vds"
									action="view"
									v-model="reserveIpFieldValue"
									:Field="reserveIpField"
									:removeRightPadding="true"
									:listBlockToOut="1"
									:fieldInModal="true" />
							</div>
							<!-- всегда 1
							<div class="w5-form-row">
								<Field
									v-if="buyField && Access"
									:isVisibleRow="true"
									crud="vds"
									action="view"
									v-model="buyValue"
									:Field="buyField"
									:needReact="true"
									@focus="onFocus(buyField)"
									@enterKeyDown="onEnterKeyDownBuy"
									:fieldInModal="true"
									:removeRightPadding="true" />
							</div>
							-->
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="buyBegin">{{ 'main/order ' + (buyType === '4' ? 'service/ip4_count' : 'service/ip6_count') | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог подтверждения -->
		<transition name="modal">
			<div v-show="showConfirmModal" @click="hideConfirmModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>
						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ confirmModalTitle | ftc }}</span>
							<button type="button" class="close" @click="hideConfirmModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(confirmModalText)"></p></div>

						<!-- подвал -->
						<div class="modal-footer">
							<span
								class="btn btn-submit pull-right"
								:class="{ 'btn-submit-danger': confirmModalDangerButton }"
								:disabled="confirmModalTimer && confirmModalTimer > 0 ? 'disabled' : false"
								@click="confirmStart">{{ modalConfirmButtonTitle }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</transition>


		
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
import Table from '@/components/elements/table'
import dropDownButton from '@/components/elements/btndropdown'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabIp',
	//=========================================================================
	// данные переданные родителем
	//=========================================================================
	props: [
		'mainIP',
		'vdsId',
		'access',
		'active',
		'ipInfo',
		'status',
		'serviceStatus',
		'parentError',
		'reserveIpData',
		'reserveIPv4List'
	],
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		countIP4() {
			if (!this.ip4) return ''
			if (this.ip4['count'] > 0)
			{
				return this.localeFtc('service/ip_count_ordered_available')
					.replace('{v}', '4')
					.replace('{ordered}', this.ip4['count'] < 0 ? 0 : this.ip4['count'])
					.replace('{available}', this.ip4['max'] < 0 ? 0 : this.ip4['max'])
			}
			else
			{
				return this.localeFtc('service/ip_count_not_ordered')
					.replace('{v}', '4')
					.replace('{available}', this.ip4['max'] < 0 ? 0 : this.ip4['max'])
			}
		},
		costIP4() {
			if (!this.ip4) return ''
			if (this.ip4['cost'] <= 0) return ''
			return this.localeFtc('service/cost_ip_title: <b>' + this.ip4['cost'] + '</b> main/ruble / ' + this.ip4['period'])
		},
		countIP6() {
			if (!this.ip6) return ''
			if (this.ip6['count'] > 0)
			{
				return this.localeFtc('service/ip_count_ordered_available')
					.replace('{v}', '6')
					.replace('{ordered}', this.ip6['count'] < 0 ? 0 : this.ip6['count'])
					.replace('{available}', this.ip6['max'] < 0 ? 0 : this.ip6['max'])
			}
			else
			{
				return this.localeFtc('service/ip_count_not_ordered')
					.replace('{v}', '6')
					.replace('{available}', this.ip6['max'] < 0 ? 0 : this.ip6['max'])
			}
		},
		costIP6() {
			if (!this.ip6) return ''
			if (this.ip6['cost'] <= 0) return ''
			return this.localeFtc('service/cost_ip_title_ipv6: <b>' + this.ip6['cost'] + '</b> main/ruble / ' + this.ip6['period'])
		},
		reserveIpCost() {
			if (!this.reserveIpData || !('cost' in this.reserveIpData)) return ''
			if (this.reserveIpData['cost'] <= 0) return ''

			return this.localeFtc('{cost} <b>main/ruble</b> / <b>{period}</b> / <b>1 {for}</b>')
				.replace('{cost}', this.reserveIpData['cost'])
				.replace('{period}', this.localeFtc(this.reserveIpData['period']))
				.replace('{for}', this.localeFtc(this.reserveIpData['for']))
		},
		hasSelectedRowsIp4() {
			let _found = false
			// ищем в ip4
			if (this.ip4 && this.ip4['rows'] && this.ip4['rows'].length)
			{
				// ищем хотя бы одну выделенную запись
				_found = this.ip4['rows'].some(item => {
					if (item['selected'] === true) return true
				})
				if (_found) return true
			}

			// ничего не нашли
			return false
		},
		hasSelectedRowsIp6() {
			let _found = false
			// ищем в ip6
			if (this.ip6 && this.ip6['rows'] && this.ip6['rows'].length)
			{
				// ищем хотя бы одну выделенную запись
				_found = this.ip6['rows'].some(item => {
					if (item['selected'] === true) return true
				})
				if (_found) return true
			}

			// ничего не нашли
			return false
		},
		// кнопка на модальном диалоге удаления
		modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete')
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)
		},
		tableUrlList() {
			return this.selectedIpId ? '/ipptrpool/list?ip_id=' + this.selectedIpId : null
		},
		tableUrlCreate() {
			return this.selectedIpId ? '/ipptrpool/create/' + this.selectedIpId : null
		},
		tableUrlUpdate() {
			return this.selectedIpId ? '/ipptrpool/update/' : null
		},
		// кнопка на модальном диалоге подтверждения
		modalConfirmButtonTitle() {
			if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc(this.modalConfirmButtonTitleText)
			return this.confirmModalTimer + ' - ' + this.localeFtc(this.modalConfirmButtonTitleText)
		}
	},
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			Access: false,
			Status: null,
			Error: '',
			mainIPData: null,
			localErrorMessage: '',
			activeProcess: false,

			rawData: null,

			ip4: {
				rows: null,
				cost: 0,
				for: '',
				max: 0,
				period: '',
				count: 0
			},
			ip6: {
				rows: null,
				cost: 0,
				for: '',
				max: 0,
				period: '',
				count: 0
			},

			// диалог удаления записи
			showDeleteModal: false,
			deleteModalTitle: 'ippool/delete_selected_title',
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteAddressType: null,
			deleteModalId: null,

			// списки адресов которые удаляют
			deletedIp4: {},
			deletedIp6: {},

			// диалог подтверждения
			showConfirmModal: false,
			confirmModalTitle: '',
			confirmModalText: '',
			modalConfirmButtonTitleText: '',
			confirmStart() {},
			confirmModalTimer: false,
			confirmModalTimerHandle: false,
			confirmModalDangerButton: false,

			// диалог смены хоста
			showHostModal: false,
			hostValue: null,
			hostField: {
				'required': true,
				'title': 'ippool/host',
				'type': 'text',
				'_field_name': 'host',
				'_visible': true,
				'_errMsg': ''
			},
			hostRow: null,
			hostModalTitle: 'ippool/host',
			hostModalContainerClass: 'wide',
			hostModalCurrentMode: '',

			// диалог покупки адресов
			showBuyModal: false,
			buyType: '4',
			buyValue: null,
			buyField: {
				'required': true,
				'title': 'main/count',
				'type': 'integer',
				'_field_name': 'buyCount',
				'_visible': true,
				'_errMsg': ''
			},
			// поля для резервирования IP в диалоге покупки
			reserveIpField: {
				required: true,
				type: 'list',
				list: [{
					'id': -1000,
					'name': this.localeFtc('main/not_use')
				}],
				title: 'server/server',
				_field_name: 'useReserveIpModalValue',
				_visible: true,
				_errMsg: ''
			},
			reserveIpFieldValue: null,

			// хендрел таймера рефреша данных по адресам
			refreshQueueHandler: null,
			// хендрел таймера рефреша данных UPDATE
			updateQueueHandler: null,

			// ID выбранного адреса
			selectedIpId: null,

			// колонки для таблицы PTR-записей
			tableColumns: {
				'ptr_address': {},
				'ptr_host': {},
				'ptr_timestamp': {
					style: 'width: 105px',
					formatter: (value) => this.formater_StrDateFormat(value)
				}
			},

			// резервирование IP
			reserveIpValue: false,
			reserveIpProcessing: false,

			// конфиг для контекстного меню в таблицах
			configOpersIp4: {
				'delete': {
					'action': 'func:delOneIP4'
				},
				'ipptrpool': {
					'title': 'ipptrpool/title',
					'action': 'func:changeHost'
				}
			},
			configOpersIp6: {
				'delete': {
					'action': 'func:delOneIP6'
				},
				'ipptrpool': {
					'title': 'ipptrpool/title',
					'action': 'func:changeHost'
				}
			}
		}
	},
	//=========================================================================
	// создание компонента
	//=========================================================================
	created() {
		this.Access = this.access
		this.Status = this.status
		this.Error = this.parentError
		this.mainIPData = this.mainIP

		if (this.ipInfo && this.ipInfo['ip4'])
		{
			this.ip4['cost'] = this.ipInfo['ip4']['cost']
			this.ip4['for'] = this.ipInfo['ip4']['for']
			this.ip4['max'] = this.ipInfo['ip4']['max']
			this.ip4['period'] = this.ipInfo['ip4']['period']
			this.ip4['count'] = this.ipInfo['ip4']['count']
		}

		if (this.ipInfo && this.ipInfo['ip6'])
		{
			this.ip6['cost'] = this.ipInfo['ip6']['cost']
			this.ip6['for'] = this.ipInfo['ip6']['for']
			this.ip6['max'] = this.ipInfo['ip6']['max']
			this.ip6['period'] = this.ipInfo['ip6']['period']
			this.ip6['count'] = this.ipInfo['ip6']['count']
		}

		this.reserveIpValue = this.reserveIpData && 'value' in this.reserveIpData
			? this.reserveIpData.value
			: false

		if (this.active) this.requestData()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)

		// отменяем прежний временной отрезок
		if (this.updateQueueHandler)
		{
			clearTimeout(this.updateQueueHandler)
			this.updateQueueHandler = null
		}

		if (this.refreshQueueHandler)
		{
			clearTimeout(this.refreshQueueHandler)
			this.refreshQueueHandler = null
		}

		if (this.confirmModalTimerHandle)
		{
			clearInterval(this.confirmModalTimerHandle)
			this.confirmModalTimerHandle = false
		}
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие всех диалогов
			if (e.keyCode === 27 && this.active)
			{
				e.preventDefault()

				// если показан дилога ptr-записей
				if (this.showHostModal)
				{
					this.hideHostModal()
					return
				}

				this.hideDeleteModal()
				this.hideHostModal()
				this.hideBuyModal()
				this.hideConfirmModal()
			}
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return
			// вкладка не активна
			if (!this.active) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== 'service') return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// может быть это ID нашего VDS?
			let _isVds = String(this.vdsId) === String(_id)
			// ищем запись с таким ID в строкe для рендеринга
			let _found = false
			if (this.ip4 && this.ip4['rows'])
			{
				_found = this.ip4['rows'].some(item => {
					if (String(item['service_id']) === String(_id) || String(item['parent_id']) === String(_id))
						return true
				})
			}

			if (!_found)
			{
				if (this.ip6 && this.ip6['rows'])
				{
					_found = this.ip6['rows'].some(item => {
						if (String(item['service_id']) === String(_id) || String(item['parent_id']) === String(_id))
							return true
					})
				}
			}

			// если это был ID нашего VDS или адреса - рефрешим данные
			if (_isVds || _found)
			{
				if (this.refreshQueueHandler) clearTimeout(this.refreshQueueHandler)

				this.refreshQueueHandler = setTimeout(() => {
					// попросить родителя обновить свои данные
					this.$emit('updateData')
					// обновить текущие данные вкладки
					this.requestData()
				}, 1500)
			}
		},
		//---------------------------------------------------------------------
		// обнуление данных по адресам
		//---------------------------------------------------------------------
		clearRows() {
			// обнулим списки адресов
			this.ip4['rows'] = null
			this.ip6['rows'] = null

			// получим главный адрес
			let _mainIP = this.getMainIP()
			if (_mainIP && _mainIP['type'])
			{
				if (_mainIP['type'] === '4')
				{
					this.ip4['rows'] = []
					this.ip4['rows'].push(_mainIP)
				}
				else if (_mainIP['type'] === '6')
				{
					this.ip6['rows'] = []
					this.ip6['rows'].push(_mainIP)
				}
			}
		},
		//---------------------------------------------------------------------
		// запрос данных по адресам
		//---------------------------------------------------------------------
		requestData() {
			// обнулим сообщение об ошибке
			this.localErrorMessage = ''

			// запоминаем выделенные строки
			let _selectedRowsIp4 = {}
			if (this.ip4['rows'] && this.ip4['rows'].length)
				this.ip4['rows'].forEach(row => {
					if (row && row['selected'] === true)
						_selectedRowsIp4[String(row['id'])] = 1
				})

			let _selectedRowsIp6 = {}
			if (this.ip6['rows'] && this.ip6['rows'].length)
				this.ip6['rows'].forEach(row => {
					if (row && row['selected'] === true)
						_selectedRowsIp6[String(row['id'])] = 1
				})

			// формируем URL запроса
			let _url = this.APIServerUrl + '/service/list'
			// параметры
			let _params = {
				'ServiceSearch': {
					'parent_id': this.vdsId
				}
			}
			// делаем запрос
			this.$http.get(_url, { 'params': _params }).then(
				// успешный ответ сервера
				res => {
					// обнулим записи здесь - что бы таблицы не моргали
					this.clearRows()

					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'ok')
					{
						// запоминаем данные как есть
						this.rawData = _dt
						// строки отдельно для каждого типа
						if (_dt['rows'] && Array.isArray(_dt['rows']) && _dt['rows'].length)
						{
							// нужно проставить данные для каждой строки
							for (let i = 0; i < _dt['rows'].length; i++)
							{
								// текущая услуга
								let _row = _dt['rows'][i]
								// пропустим не IP
								if (!_row['service_data'] ||
									!_row['service_data']['ip'] ||
									!Array.isArray(_row['service_data']['ip']) ||
									!_row['service_data']['ip'].length)
									continue

								// IP есть - бежим по всем IP доп.услуги
								_row['service_data']['ip'].forEach(ip => {
									// смотрим только если есть ID
									if ('id' in ip && ip['id'])
									{
										// формируем новый объект адреса
										let _x = {
											'id': ip['id'],
											'parent_id': _row['parent_id'],
											'service_id': _row['service_id'],
											'address': ip['ip'],
											'host': ip['host'],
											'gateway': ip['gateway'],
											'netmask': ip['netmask'],
											'status': _row['service_status'],
											'status_text': _row['service_status_text'],
											'can_delete': true,
											'selected': false
										}

										// добавим адрес
										if (ip['type'] === '4')
										{
											// проверим - была ли выделена запись или нет
											if (_selectedRowsIp4[String(_x['id'])])
												_x['selected'] = true

											// создадим массив
											if (this.ip4['rows'] === null) this.ip4['rows'] = []
											// добавим адрес
											this.ip4['rows'].push(_x)
										}
										else if (ip['type'] === '6')
										{
											// проверим - была ли выделена запись или нет
											if (_selectedRowsIp6[String(_x['id'])])
												_x['selected'] = true

											// создадим массив
											if (this.ip6['rows'] === null) this.ip6['rows'] = []
											// добавим адрес
											this.ip6['rows'].push(_x)
										}
									}
								})
							}
						}

						// на этом все
						return
					}

					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				},
				// отрицательный ответ сервера
				res => {
					// обнулим записи здесь - что бы таблицы не моргали
					this.clearRows()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				}
			)
		},
		//---------------------------------------------------------------------
		// получение главного адреса
		//---------------------------------------------------------------------
		getMainIP() {
			// если нет данных
			if (!this.mainIPData || !this.mainIPData['id'] || !this.mainIPData['system'])
			{
				return false
			}

			// формируем новый объект адреса
			return {
				'id': this.mainIPData['id'],
				'parent_id': this.vdsId,
				'service_id': this.vdsId,
				'address': this.mainIPData['ip'],
				'host': this.mainIPData['host'],
				'gateway': this.mainIPData['gateway'],
				'netmask': this.mainIPData['netmask'],
				'status': 'active',
				'status_text': null,
				'can_delete': false,
				'system': this.mainIPData['system'],
				'type': this.mainIPData['type'],
				'selected': false
			}
		},
		//---------------------------------------------------------------------
		// покупка адреса (вызов диалога)
		//---------------------------------------------------------------------
		buyIP(addressType) {
			// если процесс уже активен
			if (this.activeProcess !== false) return
			// проверка аргумента
			if (addressType !== '4' && addressType !== '6') return
			// проверка доступа
			if (!this.Access || !this.ipInfo || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// установим значение поля
			this.buyValue = 1
			this.buyField['_errMsg'] = ''

			// тип адреса
			this.buyType = addressType
			// по умолчанию - список резервных адресов
			this.reserveIpField.list = [{
				'id': -1000,
				'name': this.localeFtc('main/not_use')
			}]

			// процесс пошел - стадия 1 (показ диалога)
			this.activeProcess = 1

			// если это для маклауда покупка IPv6 - сразу покупаем 1 пул
			// 2022-03-23 - сделали такое поведение и для вдсины
			if (addressType === '6'/* && this.AppName === 'macloud'*/)
			{
				this.buyBegin()
				return
			}

			// если это покупка IPv4
			if (addressType === '4')
			{
				this.buyIP4()
				return
			}

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showBuyModal = true
		},
		// покупка IPv4
		buyIP4() {
			// по умолчанию значение
			this.reserveIpFieldValue = -1000

			// добавим резервных адресов если они есть
			if (this.reserveIPv4List && this.reserveIPv4List.list && this.reserveIPv4List.list.length)
			{
				this.reserveIpField.list = this.reserveIpField.list.concat(this.reserveIPv4List.list)
			}

			// если нет резервных адресов
			if (this.reserveIpField.list.length <= 1)
			{
				this.buyBegin()
				return
			}

			// обновим поле
			this.reserveIpField.title = this.reserveIPv4List.title

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showBuyModal = true
		},
		// закрытие диалога
		hideBuyModal(withActiveProcessFlag = true) {
			if (withActiveProcessFlag)
			{
				// процесс закончен
				this.activeProcess = false
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showBuyModal = false
			this.hideModalMask()
		},
		// нажали ENTER по полю
		onEnterKeyDownBuy() {
			this.buyBegin()
		},
		// переспросим с показом цены
		buyBegin() {
			// скроем предыдущий диалог
			this.hideBuyModal(true)

			// данные диалога
			this.confirmModalTimer = false
			this.confirmModalTimerHandle = false
			this.confirmModalDangerButton = false

			this.confirmModalTitle = this.buyType === '4'
				? 'main/order service/ip4_count'
				: 'main/order service/ip6_count'

			this.modalConfirmButtonTitleText = 'main/confirm'

			this.confirmModalText = this.buyType === '4'
				? this.costIP4
				: this.costIP6
			if (!this.confirmModalText)
			{
				let _txt = this.buyType === '4'
					? 'service/cost_ip_title'
					: 'service/cost_ip_title_ipv6'
				this.confirmModalText = this.localeFtc(`${_txt}: <b>0</b> main/ruble`)
			}

			this.confirmStart = this.buyBeginStart

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModal = true
		},
		// непосредствено покупка
		buyBeginStart() {
			// если идет процесс
			if (this.activeProcess !== false && this.activeProcess > 1) return
			// проверка доступа
			if (!this.Access || !this.ipInfo || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// получим значение
			let _count = parseInt(this.buyValue)
			// проверим границы
			if (isNaN(_count))
			{
				this.buyField['_errMsg'] = 'validators/error_int'
				return
			}
			if (_count <= 0)
			{
				this.buyField['_errMsg'] = 'error/required_field'
				return
			}
			// максимальное число
			if (this.buyType === '4')
			{
				if (_count > this.ip4['max'])
				{
					this.buyField['_errMsg'] = 'service/ip_count_max ' + this.ip4['max']
					return
				}
			}
			else
			{
				if (_count > this.ip6['max'])
				{
					this.buyField['_errMsg'] = 'service/ip_count_max_ipv6 ' + this.ip6['max']
					return
				}
			}

			// процесс идет - стадия 2 (запросы)
			this.activeProcess = 2

			// делаем запрос на редактирование VDS - в ответе есть актуальные счетчики
			this.$http.get(this.APIServerUrl + '/service/update/' + this.vdsId).then(
				// положительный ответ
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['model'] &&
						_dt['fields']['ip4_count'] && _dt['fields']['ip6_count'] &&
						_dt['_csrf'])
					{
						// готовим данные к отправке
						let _data = {
							'reinstall': 0,
							// для добавления нового адресе - просто увеличиваем соответствующий
							// счетчик адресов
							'ip4_count': _dt['fields']['ip4_count']['value'] + (this.buyType === '4' ? _count : 0),
							'ip6_count': _dt['fields']['ip6_count']['value'] + (this.buyType === '6' ? _count : 0)
						}
						if (this.reserveIpFieldValue && this.reserveIpFieldValue > 0)
						{
							_data['use_reserve_ip'] = this.reserveIpFieldValue
						}
						// делаем непосредственно запрос на покупку
						this.requestBuy(_data, _dt['_csrf'], _dt['model'])

						// на этом тут все
						return
					}

					// закрываем диалог
					this.hideBuyModal()
					// показываем ошибку
					this.localErrorMessage = this.formatRequestError(res)
				},
				// отрицательный ответ
				res => {
					// закрываем диалог
					this.hideBuyModal()
					// показываем ошибку
					this.localErrorMessage = this.formatRequestError(res)
				}
			)
		},
		// запрос на покупку
		requestBuy(postData, csrf, model) {
			// обнулим сообщения
			this.localErrorMessage = ''
			// закрываем диалог
			this.hideBuyModal(false)

			// готовим URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// готовим post-данные
			let _post = {
				'_csrf': csrf
			}
			_post[model] = postData
			// производим сразу запрос POST
			this.$http.post(_url, Helper.toFormData(_post)).then(
				// успешный ответ сервера
				resPost => {
					let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
					// если ошибки нет
					if (_dt && _dt['status'] === 'ok')
					{
						// установим успешное сообщение
						this.$emit('successMessage', 'service/ip_request_success')
						// процесс закончен
						this.activeProcess = false
						// на этом все
						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(resPost)
					// процесс закончен
					this.activeProcess = false
				},
				// отрицательный ответ сервера
				resPost => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resPost)
					// процесс закончен
					this.activeProcess = false
				}
			)
		},
		//---------------------------------------------------------------------
		// удаление адреса (вызов диалога)
		//---------------------------------------------------------------------
		delIP(addressType) {
			// если процесс уже активен
			if (this.activeProcess !== false) return
			// проверка доступа
			if (!this.Access || this.Error) return
			// проверка аргумента
			if (addressType !== '4' && addressType !== '6') return
			// обнулим сообщения
			this.localErrorMessage = ''
			this.deleteModalText = ''
			this.deleteAddressType = null
			this.deleteModalTitle = 'ippool/delete_selected_title'
			this.deleteModalId = null

			// нужно найти все выделенные записи
			let _ip4 = []
			let _ip6 = []

			// ip4
			if (addressType === '4')
			{
				if (this.ip4 && this.ip4['rows'])
				{
					this.ip4['rows'].forEach(item => {
						if (item['selected'] === true)
						{
							_ip4.push(item['address'])
						}
					})
				}
			}

			// ip6
			if (addressType === '6')
			{
				if (this.ip6 && this.ip6['rows'])
				{
					this.ip6['rows'].forEach(item => {
						if (item['selected'] === true)
						{
							_ip6.push(item['address'])
						}
					})
				}
			}

			// если нет выделенных адресов
			if (!_ip4.length && !_ip6.length) return

			// запомним типа адресов для удаления
			this.deleteAddressType = addressType

			// формируем вопрос
			let _tmp4 = ''
			let _tmp6 = ''
			// ip4
			if (_ip4.length)
			{
				_tmp4 = _ip4.join(', ')
				_tmp4 += '<br>ippool/selected_records'
				_tmp4 = this.localeFtc(_tmp4).replace('{v}', '4').replace('{count}', _ip4.length)
			}
			// ip6
			if (_ip6.length)
			{
				_tmp6 = _ip6.join(', ')
				_tmp6 += '<br>ippool/selected_records'
				_tmp6 = this.localeFtc(_tmp6).replace('{v}', '6').replace('{count}', _ip6.length)
			}
			// если уже есть какой то текст - отделим
			if (_ip4.length) this.deleteModalText = _tmp4
			if (_ip6.length)
			{
				if (this.deleteModalText !== '') this.deleteModalText += '<br><br>'
				this.deleteModalText += _tmp6
			}

			// процесс пошел - стадия 1 (показ диалога)
			this.activeProcess = 1

			// таймер
			this.deleteModalTimer = 5
			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true
			// запускаем таймер
			this.deleteModalTimerHandle = setInterval(() => {
				this.deleteModalTimer--
				if (this.deleteModalTimer <= 0)
				{
					clearInterval(this.deleteModalTimerHandle)
					this.deleteModalTimerHandle = false
				}
			}, 1000)
		},
		// событие контекстного меню
		actionOperButton(data) {
			if (!data || !data.row || !data.action) return

			if (data.action === 'ipptrpool')
			{
				this.changeHost(data.row)
				return
			}

			if (data.action === 'delete' && data.data.action)
			{
				let _parts = data.data.action.split(':')
				if (_parts[0] === 'func' && _parts[1] && this[_parts[1]])
				{
					this[_parts[1]](data.row)
				}
				return
			}
		},
		// удаление одного адрсеа
		delOneIP4(row) {
			this.delOneIP('4', row)
		},
		delOneIP6(row) {
			this.delOneIP('6', row)
		},
		delOneIP(addressType, row)
		{
			// если процесс уже активен
			if (this.activeProcess !== false) return
			// проверка доступа
			if (!this.Access || this.Error) return
			// проверка аргумента
			if (addressType !== '4' && addressType !== '6') return
			// обнулим сообщения
			this.localErrorMessage = ''
			this.deleteModalText = ''
			this.deleteAddressType = null
			this.deleteModalTitle = 'main/deleting'

			// если нет выделенных адресов
			if (!row || !row['address']) return
			this.deleteModalId = row['id']

			// запомним типа адресов для удаления
			this.deleteAddressType = addressType

			// формируем вопрос
			let _tmp = this.localeFtc('ippool/delete_title') + ': ' + row['address']
			this.deleteModalText = _tmp

			// процесс пошел - стадия 1 (показ диалога)
			this.activeProcess = 1

			// таймер
			this.deleteModalTimer = 5
			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true
			// запускаем таймер
			this.deleteModalTimerHandle = setInterval(() => {
				this.deleteModalTimer--
				if (this.deleteModalTimer <= 0)
				{
					clearInterval(this.deleteModalTimerHandle)
					this.deleteModalTimerHandle = false
				}
			}, 1000)
		},
		// закрытие диалога удаления
		hideDeleteModal(withActiveProcessFlag = true) {
			if (withActiveProcessFlag)
			{
				// процесс закончен
				this.activeProcess = false
			}

			if (this.deleteModalTimerHandle)
			{
				clearInterval(this.deleteModalTimerHandle)
				this.deleteModalTimerHandle = false
			}
			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		// непосредственное удаление
		deleteBegin() {
			// если идет процесс
			if (this.activeProcess !== false && this.activeProcess > 1) return
			// проверка счетчика
			if (this.deleteModalTimer && this.deleteModalTimer > 0) return
			// проверка доступа
			if (!this.Access || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''

			// нужно найти все выделенные записи - и сразу снять выделение
			let _ip4 = []
			let _ip6 = []

			// ip4
			if (this.deleteAddressType === '4')
			{
				// если удаляют один адрес
				if (this.deleteModalId && !this.deletedIp4[this.deleteModalId]) _ip4.push(this.deleteModalId)
				// если удаляют выделенные адреса
				else if (this.ip4 && this.ip4['rows'])
				{
					this.ip4['rows'].forEach(item => {
						if (item['selected'] === true)
						{
							if (!this.deletedIp4[item['id']]) _ip4.push(item['id'])
							item['selected'] = false
						}
					})
				}
			}

			// ip6
			if (this.deleteAddressType === '6')
			{
				// если удаляют один адрес
				if (this.deleteModalId && !this.deletedIp6[this.deleteModalId]) _ip6.push(this.deleteModalId)
				// если удаляют выделенные адреса
				else if (this.ip6 && this.ip6['rows'])
				{
					this.ip6['rows'].forEach(item => {
						if (item['selected'] === true)
						{
							if (!this.deletedIp6[item['id']]) _ip6.push(item['id'])
							item['selected'] = false
						}
					})
				}
			}

			// если нет выделенных адресов
			if (!_ip4.length && !_ip6.length) return

			// сразу скрываем диалог
			this.hideDeleteModal(false)

			// процесс идет - стадия 2 (запросы)
			this.activeProcess = 2

			// запоминаем в удаленных адресах
			// для всех этих адресов не будет показана кнопка удаления
			if (_ip4.length)
			{
				_ip4.forEach(a => { this.deletedIp4[a] = true })
			}

			if (_ip6.length)
			{
				_ip6.forEach(a => { this.deletedIp6[a] = true })
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// обновим количества
						this.ip4['count'] = _dt['fields']['ip4_count']['value']
						this.ip6['count'] = _dt['fields']['ip6_count']['value']
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {}
						_post[_dt['model']]['ip4_delete_list'] = _ip4
						_post[_dt['model']]['ip4_count'] = this.ip4['count'] - _ip4.length
						_post[_dt['model']]['ip6_delete_list'] = _ip6
						_post[_dt['model']]['ip6_count'] = this.ip6['count'] - _ip6.length
						_post[_dt['model']]['reinstall'] = 0
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/ip_remove_process')
									// процесс закончен
									this.activeProcess = false
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
								// процесс закончен
								this.activeProcess = false
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
								// процесс закончен
								this.activeProcess = false
							}
						)

						// процесс закончен
						this.activeProcess = false
						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
					// процесс закончен
					this.activeProcess = false
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
					// процесс закончен
					this.activeProcess = false
				}
			)
		},
		//---------------------------------------------------------------------
		// изменение хоста (вызов диалога)
		//---------------------------------------------------------------------
		changeHost(row, type) {
			// проверка доступа
			if (!this.Access || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// установим значение поля
			this.selectedIpId = row['id']
			this.hostValue = row['host']
			this.hostField['_errMsg'] = ''
			// запомним редактируемую строку
			this.hostRow = row
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showHostModal = true
		},
		// закрытие диалога
		hideHostModal(forceClose = true) {
			if (!forceClose)
			{
				// если это просто выход мыши за пределы даилога, например
				// при выделении мышью
				if (!this.maskModalFlag) return
			}

			if (this.hostModalCurrentMode !== 'list')
			{
				EventBus.$emit('w5-host-modal-close-event')
				return
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showHostModal = false
			this.hideModalMask()
		},
		// нажали ENTER по полю
		onEnterKeyDown() {
			this.changeHostBegin()
		},
		// епосредствено смена хоста
		changeHostBegin() {
			// проверка доступа
			if (!this.Access || this.Error) return
			// проверим наличие строки
			if (!this.hostRow) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// проверка значение поля
			if (!this.hostValue.trim())
			{
				this.hostField['_errMsg'] = 'error/required_field'
				return
			}

			// данные полей формы
			let _ipID = this.hostRow['id']
			let _ipHost = this.hostValue

			// если ID не задан
			if (_ipID === null || _ipID === undefined || _ipID === '' || _ipID < 1)
			{
				// выведем сообщение
				this.hostField['_errMsg'] = 'main/error_desc ID IP not found!'
				return
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/ippool/update/' + _ipID
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'host': _ipHost
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// меняем локально
									this.hostRow['host'] = _ipHost
									// если это главная запись
									if (this.hostRow['can_delete'] === false)
										this.mainIPData['host'] = _ipHost
									// требуется рефреш
									setTimeout(() => {
										this.requestData()
									}, 1000)
									// сразу скрываем диалог
									this.hideHostModal()
									// установим успешное сообщение
									this.$emit('successMessage', 'ippool/updated')
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// если что то передали для host
									if (_dt['fields'] && _dt['fields']['host'])
									{
										if (Array.isArray(_dt['fields']['host']))
										{
											if (_dt['fields']['host'].length)
												this.hostField['_errMsg'] = this.localeFtc(_dt['fields']['host'][0])
										}
										else this.hostField['_errMsg'] = this.localeFtc(_dt['fields']['host'])
									}

									// на этом все
									return
								}

								// сразу скрываем диалог
								this.hideHostModal()
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// сразу скрываем диалог
								this.hideHostModal()
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// сразу скрываем диалог
					this.hideHostModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// сразу скрываем диалог
					this.hideHostModal()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// фокус на поле
		//---------------------------------------------------------------------
		onFocus(field) {
			field['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// выделяет или снимает выделение со строки таблицы
		//---------------------------------------------------------------------
		selectRowInTable(e, row) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если запись нельзя удалить
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (row['can_delete'] === false) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// убираем выделение текста в браузере
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			//Helper.removeBrowserSelectionText()

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// ищем в массивах строк эту запись
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _foundIndex = -1
			let _rows
			// ip4
			if (this.ip4 && this.ip4['rows'] && this.ip4['rows'].length)
			{
				this.ip4['rows'].some((item, index, arr) => {
					if (item['id'] && item['id'] === row['id'])
					{
						// запомним индекс
						_foundIndex = index
						// запомним таблицу
						_rows = arr

						// поменяем состояние - меняем так, так как такого поля еще может и не быть вообще
						if (item['selected'] === true)
							item['selected'] = false
						else
							item['selected'] = true

						return true
					}
				})
			}

			// ищем в ip6 только если еще не нашли
			if (_foundIndex < 0)
			{
				this.ip6['rows'].some((item, index, arr) => {
					if (item['id'] && item['id'] === row['id'])
					{
						// запомним индекс
						_foundIndex = index
						// запомним таблицу
						_rows = arr

						// сразу поменяем состояние
						if (item['selected'] === true)
							item['selected'] = false
						else
							item['selected'] = true

						return true
					}
				})
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если изменили состояние хотя бы у одной записи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (_foundIndex >= 0)
			{
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// если была нажата клавиша "Shift"
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				let k = 0
				let _startIndex = -1
				let _len = _rows.length

				if (e.shiftKey)
				{
					// ищем выделенную запись выше текущей
					for (k = _foundIndex - 1; k >= 0; k--)
					{
						// если нашли выделенную запись
						if (_rows[k]['selected'] === true)
						{
							// запомним индекс
							_startIndex = k
							break
						}
					}

					// если не нашли выше - ищем выделенную запись ниже текущей
					if (_startIndex < 0)
					{
						for (k = _foundIndex + 1; k < _len; k++)
						{
							// если нашли выделенную запись
							if (_rows[k]['selected'] === true)
							{
								// запомним индекс
								_startIndex = k
								break
							}
						}
					}
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// пометить те что выше или ниже если они есть
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				if (_startIndex >= 0)
				{
					let _start = _startIndex <= _foundIndex ? _startIndex : _foundIndex
					let _end = _startIndex <= _foundIndex ? _foundIndex : _startIndex
					// бежим по всем строкам
					for (k = 0; k < _len; k++)
					{
						// если запись входит в промежуток
						if (k >= _start && k <= _end && k !== _foundIndex)
							// выделяем запись
							_rows[k]['selected'] = true
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// если пришла ошибки от потомка
		//---------------------------------------------------------------------
		getError(msg) {
			this.localErrorMessage = msg
		},
		//---------------------------------------------------------------------
		// резервирование IP
		//---------------------------------------------------------------------
		// старт процесса
		reserveIpStart() {
			if (!this.vdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если мы в процессе изменения - ничего не делаем
			if (this.reserveIpProcessing) return

			// ставим флаг начала процесса
			this.reserveIpProcessing = true
			// делаем запрос на изменение
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'])
					{
						// данные формы
						let _post = {
							'_csrf': _dt['_csrf']
						}
						_post[_dt['model']] = {
							'reserve_ip': this.reserveIpValue ? 0 : 1
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.reserveIpProcessing = false
								// проверка ответа
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id'])
								{
									// меняем значение
									this.reserveIpValue = !this.reserveIpValue
									// требуется рефреш
									setTimeout(() => {
										this.requestData()
									}, 1000)
									// а пока просто сообщим
									this.$emit('successMessage', 'main/updated')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.reserveIpProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг процесса
					this.reserveIpProcessing = false
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг процесса
					this.reserveIpProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// диалог подтверждения
		//---------------------------------------------------------------------
		// закрытие диалога
		hideConfirmModal() {
			if (this.confirmModalTimerHandle)
			{
				clearInterval(this.confirmModalTimerHandle)
				this.confirmModalTimerHandle = false
			}

			this.activeProcess = false

			EventBus.$emit('w5-body-scroll-enable')
			this.showConfirmModal = false
			this.hideModalMask()
		}
		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'access': function(access) {
			this.Access = access
		},
		'active': function(value) {
			if (this.active) this.requestData()
		},
		'status': function(status) {
			this.Status = status
		},
		'mainIP': function(ip) {
			this.mainIPData = ip
		},
		'ipInfo': function(info) {
			if (info && info['ip4'])
			{
				this.ip4['cost'] = info['ip4']['cost']
				this.ip4['for'] = info['ip4']['for']
				this.ip4['max'] = info['ip4']['max']
				this.ip4['period'] = info['ip4']['period']
				this.ip4['count'] = info['ip4']['count']
			}

			if (info && info['ip6'])
			{
				this.ip6['cost'] = info['ip6']['cost']
				this.ip6['for'] = info['ip6']['for']
				this.ip6['max'] = info['ip6']['max']
				this.ip6['period'] = info['ip6']['period']
				this.ip6['count'] = info['ip6']['count']
			}
		},
		'parentError': function(value) {
			this.Error = value
		},
		'hostModalCurrentMode': function(value) {
			this.$emit('flagCloseModals', value !== 'list')
		},
		'reserveIpData': function(data) {
			this.reserveIpValue = data && 'value' in data
				? data.value
				: false
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field,
		dropDownButton,
		Table
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.ip-count-info {
	margin: 10px 0;
	margin-top: 15px;
	padding: 10px;
	font-size: 95%;
	border: 1px solid #eee;
	border-radius: 4px;
}   

.ip-count-info-ip {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: flex-start;
	-webkit-align-items: center;
}

@media (max-width: 767px) {
	.ip-count-info-ip {
		flex-direction: column;
		align-items: start;
		-webkit-align-items: start;
	}
}

.ip-count-info-ip-item {
	display: inline-block;
}

.ip-trash-button {
	position: relative;
	font-size: 17px;
	color: #999;    
}

.ip-trash-button.small {
	font-size: 13px;
}

.ip-trash-button-active {
	color: red;
	cursor: pointer;
}

.w5-ip-table-th-0 {
	width: 160px;
}
.w5-ip-table-th-2 {
	width: 160px;
}
.w5-ip-table-th-3 {
	width: 120px;
}
.w5-ip-table-th-4 {
	width: 50px;
}
</style>



// WEBPACK FOOTER //
// ip.vue?83bfcdfa